/**
 * 잠든 개·고양이 연필 라인 실루엣 — "세는 사람의 기록지" 시각 언어(완성 계획 6절).
 *
 * 브리프(작성 2026-10-16, image-craft 경로: 손으로 그린 벡터):
 * - 대상: 노령·만성질환 아이의 보호자. 순간: 아이 사진이 아직 없을 때 빈 자리를 채우는 조용한 그림.
 * - 형태: 옆으로 누워 잠든 자세, 한 굵기(2.6/160) 둥근 끝 선, 채움 없음. 표정은 감은 눈 한 획.
 * - 색: currentColor(데이터 잉크 --color-ink). 장식 그라디언트·하트·발바닥 금지.
 * - 반복 금지: 같은 그림을 빈 상태·OG·기능 설명에 되풀이하지 않는다(사진이 없을 때 1곳, 랜딩 1곳).
 * - 실측: 390px 화면에서 폭 160~200px로 렌더해 눈으로 확인(evidence/completion-2026-10).
 */
export function SleepingPet({ species, className, title }: { species: 'dog' | 'cat'; className?: string; title?: string }) {
  return species === 'cat' ? <SleepingCat className={className} title={title} /> : <SleepingDog className={className} title={title} />;
}

export function SleepingDog({ className, title, tally = false }: { className?: string; title?: string; tally?: boolean }) {
  return <svg className={className} viewBox={tally ? '0 0 360 160' : '0 0 320 160'} role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
    <g fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 148 H306" className="line-art-ground" strokeWidth="1.6" />
      <path d="M116 72 C150 58 222 58 254 76 C278 89 288 112 283 136" />
      <path d="M76 76 C88 68 106 66 116 72" />
      <path d="M76 76 C70 80 66 84 63 88 C52 92 40 96 33 100 C27 104 29 112 37 113 C46 114 54 116 60 120 C72 126 88 126 98 120" />
      <path d="M90 76 C106 82 112 104 102 116 C96 122 87 117 88 106" />
      <path d="M64 95 C68 98 73 98 77 95" />
      <path d="M98 122 C84 130 56 132 34 131 C24 131 22 141 30 143 L283 136" />
      <path d="M266 140 C260 114 226 108 212 126 C206 136 196 142 180 143" />
      <path d="M281 126 C300 124 308 138 296 143 C284 147 262 146 248 145" />
      {tally ? <g className="line-art-tally" strokeWidth="3.4"><path d="M300 34 H344" /><path d="M322 34 V78" /><path d="M322 56 H338" /><path d="M306 54 V78" /><path d="M298 78 H346" /></g> : null}
    </g>
    <circle cx="31" cy="104" r="3" fill="currentColor" />
  </svg>;
}

export function SleepingCat({ className, title }: { className?: string; title?: string }) {
  return <svg className={className} viewBox="0 0 320 160" role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
    <g fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 146 H306" className="line-art-ground" strokeWidth="1.6" />
      <path d="M112 72 C140 54 200 50 236 66 C266 80 278 108 268 128 C260 140 236 142 212 141 L128 141" />
      <path d="M112 72 C100 64 82 62 70 68 L64 46 L84 60 C92 57 100 57 108 60 L120 44 L118 70" />
      <path d="M70 68 C58 80 58 100 70 110 C82 120 104 120 116 110 C124 102 124 88 118 78" />
      <path d="M76 92 C80 95 85 95 89 92" />
      <path d="M98 92 C102 95 107 95 111 92" />
      <path d="M90 102 L93 105 L96 102" />
      <path d="M70 110 C66 126 74 140 96 141 L128 141" />
      <path d="M268 126 C286 132 288 146 270 148 C240 151 190 149 150 147 C136 146 130 142 132 138" />
      <path d="M60 100 L44 98 M60 106 L46 108 M126 100 L140 98" strokeWidth="1.6" opacity=".7" />
    </g>
  </svg>;
}
